class PackBuilder {
  constructor() {
    this.state = {
      selectedTier: null,
      products: new Map(),
      currentQty: 0,
      maxQty: 0
    };
    
    this.init();
  }

  init() {
    this.cacheDOM();
    this.bindEvents();
    
    // Auto-sélection du premier pack
    if (this.dom.tiers.length > 0) {
      this.selectTier(this.dom.tiers[0]);
    }
  }

  cacheDOM() {
    this.dom = {
      tiers: document.querySelectorAll('.bundle-option'),
      cards: document.querySelectorAll('.product-card'),
      currentCount: document.querySelector('.current-count'),
      maxCount: document.querySelector('.max-count'),
      progressBar: document.querySelector('.progress-bar-fill'),
      addToCartBtn: document.querySelector('.add-to-cart-btn'),
      resetBtn: document.querySelector('.reset-btn')
    };
  }

  bindEvents() {
    this.dom.tiers.forEach(tier => {
      tier.addEventListener('click', (e) => this.selectTier(e.currentTarget));
    });

    this.dom.cards.forEach(card => {
      const addBtn = card.querySelector('.add-to-selection-btn');
      if(addBtn) addBtn.addEventListener('click', () => this.incrementProduct(card));

      const incBtn = card.querySelector('.quantity-increment-btn');
      if(incBtn) incBtn.addEventListener('click', () => this.incrementProduct(card));

      const decBtn = card.querySelector('.quantity-decrement-btn');
      if(decBtn) decBtn.addEventListener('click', () => this.decrementProduct(card));
    });

    if(this.dom.resetBtn) {
      this.dom.resetBtn.addEventListener('click', () => this.resetAll());
    }

    if(this.dom.addToCartBtn) {
      this.dom.addToCartBtn.addEventListener('click', () => this.addToCart());
    }
  }

  // --- LOGIQUE METIER ---
  selectTier(tierElement) {
    this.dom.tiers.forEach(t => t.classList.remove('selected'));
    tierElement.classList.add('selected');

    this.state.selectedTier = {
      id: tierElement.dataset.packVariantId,
      limit: parseInt(tierElement.dataset.quantity)
    };

    this.state.maxQty = this.state.selectedTier.limit;
    
    if (this.state.currentQty > this.state.maxQty) {
      this.resetAll();
    } else {
      this.updateGlobalUI();
    }
  }

  incrementProduct(card) {
    if (this.state.currentQty >= this.state.maxQty) {
      // Optionnel : petite alerte ou secousse visuelle
      return;
    }

    const id = card.dataset.productId;
    const title = card.dataset.productTitle;

    if (!this.state.products.has(id)) {
      this.state.products.set(id, { title: title, qty: 0 });
    }

    const product = this.state.products.get(id);
    product.qty++;
    this.state.currentQty++;

    this.updateCardUI(card, product.qty);
    this.updateGlobalUI();
  }

  decrementProduct(card) {
    const id = card.dataset.productId;
    if (!this.state.products.has(id)) return;

    const product = this.state.products.get(id);
    
    if (product.qty > 0) {
      product.qty--;
      this.state.currentQty--;
    }

    if (product.qty === 0) {
      this.state.products.delete(id);
    }

    this.updateCardUI(card, product.qty);
    this.updateGlobalUI();
  }

  resetAll() {
    this.state.products.clear();
    this.state.currentQty = 0;
    this.dom.cards.forEach(card => this.updateCardUI(card, 0));
    this.updateGlobalUI();
  }

  // --- UI UPDATES ---
  updateCardUI(card, qty) {
    const addBtn = card.querySelector('.add-to-selection-btn');
    const controls = card.querySelector('.quantity-control-wrapper');
    const input = card.querySelector('.quantity-input');

    if (qty > 0) {
      addBtn.style.display = 'none';
      controls.style.display = 'flex';
      input.value = qty;
      card.classList.add('is-selected');
    } else {
      addBtn.style.display = 'block';
      controls.style.display = 'none';
      input.value = 0;
      card.classList.remove('is-selected');
    }
  }

  updateGlobalUI() {
    this.dom.currentCount.textContent = this.state.currentQty;
    this.dom.maxCount.textContent = this.state.maxQty;

    const pct = (this.state.currentQty / this.state.maxQty) * 100;
    this.dom.progressBar.style.width = `${pct}%`;

    const remaining = this.state.maxQty - this.state.currentQty;
    
    if (remaining === 0 && this.state.maxQty > 0) {
      this.dom.addToCartBtn.textContent = "AJOUTER AU PANIER";
      this.dom.addToCartBtn.disabled = false;
      this.dom.addToCartBtn.classList.remove('disabled');
    } else {
      this.dom.addToCartBtn.textContent = `IL MANQUE ${remaining} PARFUMS`;
      this.dom.addToCartBtn.disabled = true;
      this.dom.addToCartBtn.classList.add('disabled');
    }
  }

  // --- AJOUT PANIER + OUVERTURE DRAWER ---
  async addToCart() {
    if (!this.state.selectedTier || !this.state.selectedTier.id) {
      alert("Erreur de configuration : Aucun produit Pack lié.");
      return;
    }

    let descriptionList = [];
    this.state.products.forEach((val) => {
      descriptionList.push(`${val.title} (x${val.qty})`);
    });
    const compositionNote = descriptionList.join(', ');

    const payload = {
      items: [{
        id: this.state.selectedTier.id,
        quantity: 1,
        properties: {
          'Composition': compositionNote
        }
      }],
      sections: "cart-drawer,cart-icon-bubble" // Pour les thèmes Dawn/Modernes
    };

    const btn = this.dom.addToCartBtn;
    
    try {
      btn.textContent = "Ajout en cours...";
      btn.disabled = true;

      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      if (response.ok) {
        // 1. Notification visuelle rapide
        const originalText = "AJOUTER AU PANIER";
        btn.textContent = "AJOUTÉ !";
        
        // 2. Tenter de rafraîchir le panier (Events standards Shopify)
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));

        // 3. OUVRIR LE DRAWER (L'astuce universelle)
        // On cherche l'icône du panier dans le header et on clique dessus virtuellement
        setTimeout(() => {
          // Sélecteurs courants pour l'icône panier (Dawn, Prestige, Impulse, etc.)
          const cartIcon = document.querySelector('a[href="/cart"], #cart-icon-bubble, .header__icon--cart, [data-action="open-cart"]');
          
          // Essai spécifique pour thème Dawn (Gratuit Shopify)
          const dawnDrawer = document.querySelector('cart-drawer');
          const dawnNotification = document.querySelector('cart-notification');

          if (dawnDrawer) {
            // Méthode Theme Dawn
            dawnDrawer.classList.add('active'); // Parfois nécessaire
            const sectionData = response.json().then(data => {
               // Mise à jour éventuelle du DOM Dawn ici si besoin, 
               // mais souvent le simple clic ou event suffit.
            });
          }

          if (cartIcon) {
            cartIcon.click(); // Le clic magique !
          } else {
            // Si vraiment on ne trouve pas le drawer, on redirige (Secours)
            window.location.href = '/cart';
          }
        }, 500);

        // 4. Reset du bouton après quelques secondes
        setTimeout(() => {
          btn.disabled = false;
          btn.textContent = originalText;
          // Optionnel : this.resetAll(); // Si vous voulez vider la sélection après ajout
        }, 2000);

      } else {
        throw new Error('Erreur Shopify');
      }
    } catch (error) {
      console.error(error);
      alert("Erreur lors de l'ajout au panier.");
      btn.textContent = "AJOUTER AU PANIER";
      btn.disabled = false;
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new PackBuilder();
});